<template>
  <section class="community-preview animate-box">
    <div class="info">
      <h2>丰富多元的社区内容</h2>
      <p>从技术深耕到生活美学，来秋为您呈现最有价值的数字景观。</p>
    </div>
    <div class="image-showcase">
      <div class="img-box box-1"><span>技术沙龙</span></div>
      <div class="img-box box-2"><span>艺术策展</span></div>
      <div class="img-box box-3"><span>开发者大会</span></div>
    </div>
  </section>
</template>

<style scoped>
.community-preview {
  display: flex;
  padding: 100px 0;
  align-items: center;
}

.community-preview .info {
  padding: 0 10%;
  width: 40%;
}

.image-showcase {
  display: flex;
  gap: 1rem;
  width: 60%;
}

.img-box {
  height: 400px;
  flex: 1;
  background: #222;
  display: flex;
  align-items: flex-end;
  padding: 20px;
  transition: flex 0.6s cubic-bezier(0.25, 1, 0.5, 1);
  background-size: cover;
  background-position: center;
  color: #fff;
}

.img-box:hover {
  flex: 2;
}

.box-1 {
  background-image: url('/src/assets/2.jpg');
}

.box-2 {
  background-image: url('/src/assets/3.jpg');
}

.box-3 {
  background-image: url('/src/assets/1.jpg');
}

@media (max-width: 768px) {
  .community-preview {
    flex-direction: column;
  }

  .image-showcase {
    width: 100%;
    padding: 2rem;
  }

  .community-preview .info {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>